// @flow

import Game from '@/lib/game';
import UnitTemplates from '@/lib/unit_templates';

/**
 * ユーザーの保有する資産を管理する
 */
export default class {
  game: Game;
  _gold: number;
  _units: { amount: number, template: UnitTemplate }[];

  constructor(game: Game) {
    this.game = game;
    this._gold = 0;
    this._units = [];
  }

  get gold() {
    return this._gold;
  }

  get units() {
    return this._units;
  }

  addGold(amount: number) {
    this._gold += amount;
  }

  reduceGold(amount: number) {
    this._gold -= amount;
  }

  findUnitIndex(unitType: string) {
    const index = this._units.findIndex(
      unit => unit.template.type === unitType
    );

    if (index === -1) {
      return null;
    } else {
      return index;
    }
  }

  addUnit(unitTemplate: UnitTemplate): boolean {
    const i = this.findUnitIndex(unitTemplate.type);

    if (i === null) {
      this._units.push({
        amount: 1,
        template: unitTemplate,
      });
    } else {
      this._units[i].amount++;
    }

    return true;
  }

  reduceUnit(unitTemplate: UnitTemplate): boolean {
    const i = this.findUnitIndex(unitTemplate.type);
    if (i === null) return false;
    if (this._units[i].amount <= 1) {
      this._units.splice(i, 1);
      return true;
    }
    this._units[i].amount--;

    return true;
  }

  findUnitAmount(unitTemplate: UnitTemplate) {
    const i = this.findUnitIndex(unitTemplate.type);

    if (i === null) {
      return 0;
    } else {
      return this._units[i].amount;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/asset_manager/asset_manager.js